import { render } from "./BalanceRecord.vue?vue&type=template&id=20ed8e5c&scoped=true"
import script from "./BalanceRecord.vue?vue&type=script&lang=js"
export * from "./BalanceRecord.vue?vue&type=script&lang=js"

import "./BalanceRecord.vue?vue&type=style&index=0&id=20ed8e5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ed8e5c"]])

export default __exports__